module.exports = require("@swa-ui/core/src/Transform/Transform.module.scss");